import React from 'react';

const services = [
  {
    label: 'Choose your fund',
    desc: 'Select from a curated list of tax-efficient mutual funds tailored to meet your investment goals..',
  },
  {
    label: 'Make payment',
    desc: 'Invest seamlessly with our secure, straightforward payment process tailored for convenience..',
  },
  {
    label: 'Track your investment',
    desc: 'Monitor your mutual fund performance and tax savings in real-time through your personalized dashboard..',
  },
];

const MutualInvest = () => {
  return (
    <div className="services-section container py-5">
      <h1 className="text-center fw-bold mb-5">How to invest in mutual funds with taxNwealth?</h1>
      <div className="row g-4">
        {services.map((service, index) => (
          <div className="col-md-4" key={index}>
            <div className="service-card p-4 h-100 rounded-4 shadow-sm text-start">
              <div
                className="icon-box text-white fs-1 mb-3 d-flex justify-content-center align-items-center"
                style={{
                  backgroundColor: 'rgb(0 89 173 )', 
                  width: '40px', 
                  height: '40px', 
                  borderRadius: '50%',
                }}
              >
                {index + 1}
              </div>
              <h5 className="fw-bold mb-2">{service.label}</h5>
              <p className="text-muted">{service.desc}</p>
              {/* <a href="#" className="fw-bold text-primary text-decoration-none">
                Learn more <i className="bi bi-arrow-right"></i>
              </a> */}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MutualInvest;
